// Vue
import Vue from 'vue'
import App from './App.vue'

// Extensions
import './extensions/firebase/index'

// Vue HTTP
import VueResource from 'vue-resource'
Vue.use(VueResource)

// Validator
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

// PWA
import './registerServiceWorker'

// Router & Store
import { store, router } from './sr.js'

// Connectors
import './tipos/index'
import './utils/connector'

// Vuetify
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import { theme } from './config.js'

// General components
// 0. Iterators
import compDataIterator from '@/components/Tables/TableIterator'
Vue.component('comp-data-iterator', compDataIterator)

// 1. Forms
import compFormDefault from './tipos/forms/views/General'
Vue.component('comp-form-default', compFormDefault)

// 2. Campos
import compFields from './components/TextField/Field'
Vue.component('comp-fields', compFields)

// 3. Datepickers
import compBirthDate from './components/Datepicker/BirthDate'
Vue.component('comp-field-birth-date', compBirthDate)

import compTimepicker from './components/Datepicker/TimePicker'
Vue.component('comp-field-time-picker', compTimepicker)

import compDate from './components/Datepicker/Date'
Vue.component('comp-field-date', compDate)

// 4. Search
import compFieldSearch from './components/TextField/SearchField'
Vue.component('comp-search-field', compFieldSearch)

// 5. Tables
import compTableArray from './components/Tables/Table'
Vue.component('comp-field-array-table', compTableArray)

// 6. ArrayField
import compArrayFields from './components/ArrayField/Field' 
Vue.component('comp-array-fields', compArrayFields)

///

Vue.use(Vuetify, {
  theme
})

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
